export enum SearchParams {
  UI_REFERRAL_TEAM_ID = 'rtid',
  UI_REFERRAL_PREDICTION_ID = 'rpid',
  UI_REFERRAL_USER_ID = 'ruid',
  UI_REFERRAL_CONTEST_ID = 'cuid',
  UI_REFERRAL_SECURITY_ID = 'tsid', // tradegram security id
}